// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--3-oneOf-1-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--3-oneOf-1-3!../../node_modules/vuetify-loader/lib/loader.js??ref--19-0!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Parallax.vue?vue&type=style&index=0&id=06f4e1a2&scoped=true&lang=css&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("35b2cb9e", content, true, {"sourceMap":false});